export const ADD_VEHICLES = 'ADD_VEHICLES';
export const SET_VEHICLES = 'SET_VEHICLES';

export const SET_LISTING_USED = 'SET_LISTING_USED';

export const SELECT_PURCHASE_METHOD = 'SELECT_PURCHASE_METHOD';
export const SELECT_MAXIMUM_TERM = 'SELECT_MAXIMUM_TERM';
export const SELECT_PREFERRED_PAYMENT_FREQUENCY = 'SELECT_PREFERRED_PAYMENT_FREQUENCY';
export const SET_INITIAL_CASH_DOWN = 'SET_INITIAL_CASH_DOWN';
export const SET_INITIAL_TARGET_PAYMENT = 'SET_INITIAL_TARGET_PAYMENT';
export const SET_PAYMENT_RANGE = 'SET_PAYMENT_RANGE';
export const SET_VEHICLE_SORT = 'SET_VEHICLE_SORT';
export const SET_VEHICLE_CRITERIA = 'SET_VEHICLE_CRITERIA';
export const SET_CONTEXT_URL = 'SET_CONTEXT_URL';
export const SET_VDP_URL = 'SET_VDP_URL';
export const SET_DEALER_MAKE = 'SET_DEALER_MAKE';
export const SET_COLANDERS = 'SET_COLANDERS';
export const SET_METADATAS = 'SET_METADATAS';

export const SET_PREFERRED_PURCHASE_METHOD = 'SET_PREFERRED_PURCHASE_METHOD';
export const REPLACE_URL = 'REPLACE_URL';



// WEBPACK FOOTER //
// ./client/src/actions/listingUsedActionTypes.js